import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WarehousesPage } from '@/features/data/warehouses/warehouses-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Entrée « Entrepôt SQL » de la navigation : la liste des entrepôts (porting README #73). */
export const Route = createFileRoute('/$tenant/sql/')({ component: WarehousesRoute });

function WarehousesRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="sql" crumbs={[{ label: t('nav.items.sql') }]}>
      <WarehousesPage tenantId={tenant} />
    </ConsoleShell>
  );
}
